
<template>
  <div>
    <a href='#' @click.prevent.stop='isShown = !isShown' class='newkb__sidebar__buttons--button button button--large button--block button--success'><i class='fas fa-plus'></i>New...</a>
    <transition name='popopen'>
      <slot v-if='isShown'>
      </slot>
    </transition>
  </div>
</template>

<script>


export default {
  props: [],
  data () {
    return {
      isShown: false
    }
  },
  methods: {
    
  },

}
</script>

